/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

/*       */

import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';

import { fetchProgramsForChannelsIfNeeded } from '../actions';
import Simple from '../components/Simple';
import { getProgramsForNowByZapNumber } from '../selectors';
import { HEADERS_NOW, PER_PAGE } from '../constants';

const mapStateToProps = state => ({
  perPage: PER_PAGE,
  headers: HEADERS_NOW,
  programs: getProgramsForNowByZapNumber(state)
});

const mapDispatchToProps = {
  fetchProgramsForChannelsIfNeeded
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation()
)(Simple);
